<ng-template #menu>
    @if ($dataObject(); as dataObject) {
        <div cdkMenu class="cm-menu">
            <div class="cm-heading">Download as:</div>
            <!-- The .EXR option serves the raw result data object, so only offer it when that object
                 really is an EXR. A manually assigned shader ball (e.g. an uploaded JPG) is not, and
                 must not be downloadable under an .EXR label. -->
            @if (dataObject.mediaType === "image/x-exr") {
                <a cdkMenuItem class="cm-item" [href]="dataObject.downloadUrl" [download]="dataObject.originalFileName ?? ''">.EXR</a>
            } @else {
                <span class="cm-item cm-disabled">.EXR</span>
            }
            @if (dataObject.jpeg?.downloadUrl; as jpegUrl) {
                <a cdkMenuItem class="cm-item" [href]="jpegUrl" download>.JPEG</a>
            } @else {
                <span class="cm-item cm-disabled">.JPEG</span>
            }
            @if (dataObject.tiff?.downloadUrl; as tiffUrl) {
                <a cdkMenuItem class="cm-item" [href]="tiffUrl" download>.TIFF</a>
            } @else {
                <span class="cm-item cm-disabled">.TIFF</span>
            }
        </div>
    }
</ng-template>
